import { equals } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import { connect } from '@atlassian/jira-react-redux';
import mapDispatchToProps from './command';
import mapStateToProps from './query';
import View from './view';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const arePropsEqual = (a: any, b: any) => equals(a, b, 256);

export const Issue = connect(mapStateToProps, mapDispatchToProps, null, {
	areOwnPropsEqual: arePropsEqual,
	areStatePropsEqual: arePropsEqual,
})(View);

export default Issue;
